export const formatCurrencyBRL = (item: string | number): string | number => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(Number(item))
}
